import { render, staticRenderFns } from "./FileReader.vue?vue&type=template&id=21ed4b9c&"
import script from "./FileReader.vue?vue&type=script&lang=js&"
export * from "./FileReader.vue?vue&type=script&lang=js&"
import style0 from "./FileReader.vue?vue&type=style&index=0&id=21ed4b9c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports